import { GitBranch, AlertCircle, AlertTriangle, Play } from 'lucide-react';

const STATUS_TEXT = {
  0: 'Ready',
  1: 'Typing…',
  2: 'Ready',
  3: 'Build started…',
  4: 'Debugging',
};

export default function StatusBar({ step = 0, lineCount = 1, col = 1 }) {
  return (
    <div
      className="flex items-center h-[22px] text-white text-[11px] flex-shrink-0 transition-colors duration-300"
      style={{ background: step >= 3 ? '#CA5100' : '#007ACC' }}
    >
      {/* Left */}
      <div className="flex items-center h-full">
        <div className="flex items-center gap-1 px-2 h-full hover:bg-black/15 cursor-pointer">
          <GitBranch size={12}/> main
        </div>
        <div className="flex items-center gap-1 px-2 h-full hover:bg-black/15 cursor-pointer">
          <AlertCircle size={11}/> 0
          <AlertTriangle size={11} className="ml-1"/> 0
        </div>
      </div>
      {/* Status text */}
      <div className="px-2">{STATUS_TEXT[step] || 'Ready'}</div>
      {/* Right */}
      <div className="flex items-center h-full ml-auto">
        {[`Ln ${lineCount}, Col ${col}`, 'Spaces: 4', 'UTF-8', 'CRLF', 'C#'].map(t => (
          <div key={t} className="px-2 h-full flex items-center hover:bg-black/15 cursor-pointer">{t}</div>
        ))}
        <div className="flex items-center gap-1 px-2 h-full hover:bg-black/15 cursor-pointer">
          <Play size={11} className="fill-white"/> HelloWorld
        </div>
      </div>
    </div>
  );
}
